/* istanbul ignore file -- @preserve */
import { useMutation } from '@apollo/client';
import removeContactFromDepotMutation from 'pages/Management/Depot/ContactsTab/RemoveFromDepotModal/hooks/removeContactFromDepotMutation.graphql';

const useRemoveContactFromDepotMutation = () => {
  return useMutation(removeContactFromDepotMutation, {
    refetchQueries: ['ManagedPlatformAccountContacts', 'DepotContacts'],
  });
};

export default useRemoveContactFromDepotMutation;
